module.exports = "<div ng-click=\"showDrawer = !showDrawer\" class=\"icon\" ng-class=\"{'accordion-closed': !showDrawer, 'accordion-open': showDrawer }\"></div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridAccordionToggleCell/tableGridAccordionToggleCell.html
// module id = 486
// module chunks = 1